// Costruisce il JSON dei dati cliente per il form Aruba (fatturazione elettronica).
// Omette i campi vuoti. Le chiavi di output seguono l'elenco richiesto; alcune hanno
// sorgenti alternative (es. piva da partita_iva, comune da citta nella proforma).
// CAP = codice postale (5 cifre); Provincia = sigla (2 lettere).

import COMUNI from "./comuni";

const JSON_FIELDS = [
  { out: "id_paese", keys: ["id_paese"] },
  { out: "piva", keys: ["piva", "partita_iva"] },
  { out: "codice_fiscale", keys: ["codice_fiscale"] },
  { out: "nome", keys: ["nome"] },
  { out: "cognome", keys: ["cognome"] },
  { out: "codice_eori", keys: ["codice_eori", "eori"] },
  { out: "cap", keys: ["cap"] },
  { out: "provincia", keys: ["provincia"] },
  { out: "comune", keys: ["comune", "citta"] },
  { out: "indirizzo", keys: ["indirizzo"] },
  { out: "numero_civico", keys: ["numero_civico"] },
  { out: "nazione", keys: ["nazione"] },
  { out: "email", keys: ["email"] },
  { out: "pec", keys: ["pec"] },
  { out: "telefono", keys: ["telefono"] },
  { out: "fax", keys: ["fax"] },
  { out: "riferimento_amministrazione", keys: ["riferimento_amministrazione", "rif_amministrazione", "riferimento_amm"] },
];

// Mappa comune -> sigla provincia (dal dataset comuni locale), per derivare la sigla
// quando la provincia è salvata per esteso (es. "PALERMO" -> "PA").
const _siglaByComune = (() => {
  const m = new Map();
  for (const c of COMUNI) {
    const k = (c.nome || "").trim().toLowerCase();
    if (k && !m.has(k)) m.set(k, c.provincia);
  }
  return m;
})();

const isSigla = (v) => /^[A-Za-z]{2}$/.test(v || "");
const isCap = (v) => /^\d{5}$/.test(v || "");

export function buildArubaClientJSON(data) {
  const get = (keys) => {
    for (const k of keys) {
      const v = data?.[k];
      if (v != null && String(v).trim() !== "") return String(v).trim();
    }
    return "";
  };

  const vals = {};
  for (const f of JSON_FIELDS) vals[f.out] = get(f.keys);

  // Correzione CAP/Provincia: il CAP deve essere il codice postale (5 cifre), la Provincia
  // la sigla (2 lettere).
  let cap = vals.cap;
  let provincia = vals.provincia;
  // Auto-correggi un'eventuale inversione (cap con sigla, provincia con codice postale).
  if (isSigla(cap) && isCap(provincia)) {
    const tmp = cap; cap = provincia; provincia = tmp;
  }
  // Se la provincia non è una sigla di 2 lettere (es. salvata per esteso), derivala dal comune.
  if (!isSigla(provincia)) {
    const s = _siglaByComune.get((vals.comune || "").trim().toLowerCase());
    if (s) provincia = s;
  }
  if (isSigla(provincia)) provincia = provincia.toUpperCase();
  vals.cap = cap;
  vals.provincia = provincia;

  const obj = {};
  for (const f of JSON_FIELDS) {
    const v = vals[f.out];
    if (v) obj[f.out] = v;
  }
  return JSON.stringify(obj, null, 2);
}
